import React, { useCallback } from "react";
import { Card } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

interface Props {
  organization: Organization;
}

const Organization: React.FC<Props> = ({ organization }) => {
  const navigate = useNavigate();
  const onClick = useCallback(() => {
    navigate(`/${organization._id}`);
  }, [navigate, organization._id]);

  return (
    <Card
      hoverable
      onClick={onClick}
      style={{ marginBottom: 12 }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontSize: 16, fontWeight: 500 }}>{organization.name}</span>
        <RightOutlined style={{ color: "rgba(0,0,0,0.25)" }} />
      </div>
    </Card>
  );
};

export default Organization;
